//Smart Contract Address
//export const smartContractAddress = '0x8B86Efbe8E6f0D09511DE1AbC1C0663896acFEa2';
//export const smartContractAddress = '0xfd3D0703F605A37B8A72501e71fCE7137FD3Af62';
export const smartContractAddress = '0xe7aF60280612eb99263f305c0C61D837aa5D1CE2';


//Credit WEI Value
export const creditWeiCost = 100000000000000;

//API Base URL
export const baseURL = 'https://us-central1-gameforcrypto.cloudfunctions.net';

//Available Entry Fees
export const availableEntryFees = [10, 20, 30, 40, 50, 100, 200];